var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "static-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("Header", { attrs: { title: "Metropolitan Museum of Art" } })
            ]
          },
          proxy: true
        },
        {
          key: "info-area",
          fn: function() {
            return [_c("TopInfo")]
          },
          proxy: true
        },
        {
          key: "footer",
          fn: function() {
            return undefined
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      [
        _c("div", [
          _c(
            "div",
            { staticClass: "adjust" },
            [
              _c(
                "CarouselOne",
                { attrs: { max: 2 } },
                [
                  _c("slide", [
                    _c("div", { staticClass: "d-flex slide-type-2" }, [
                      _c("div", [_c("div")]),
                      _vm._v(" "),
                      _c("div", [
                        _c("h2", [_vm._v("Per gli amanti dell'arte 2")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Il Metropolitan Museum of Art, a cui spesso ci si riferisce con il nomignolo di \"The Met\", è uno dei più grandi ed importanti musei del mondo.\n                                    La sua sede principale si trova sul lato sinistro del Central Park a New York, lungo quello che viene chiamato il Museum Mile.\n                                    Nel 1986 è stato inserito nella lista dei National Historic Landmark. Il Met dispone anche di una sede secondaria, chiamata The Cloisters, che contiene la sezione dedicata all'arte medievale.\n                                    La collezione permanente del Met contiene più di due milioni di opere d'arte, suddivise in diciannove sezioni. Sono permanentemente esposte opere risalenti all'antichità classica e all'antico Egitto, dipinti e sculture di quasi tutti i più grandi maestri Europei e una vasta collezione di arte statunitense e moderna."
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("slide", [
                    _c("div", { staticClass: "d-flex slide-type-2" }, [
                      _c("div", [_c("div")]),
                      _vm._v(" "),
                      _c("div", [
                        _c("h2", [_vm._v("Per gli amanti dell'arte 2")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Il Metropolitan Museum of Art, a cui spesso ci si riferisce con il nomignolo di \"The Met\", è uno dei più grandi ed importanti musei del mondo.\n                                    La sua sede principale si trova sul lato sinistro del Central Park a New York, lungo quello che viene chiamato il Museum Mile.\n                                    Nel 1986 è stato inserito nella lista dei National Historic Landmark. Il Met dispone anche di una sede secondaria, chiamata The Cloisters, che contiene la sezione dedicata all'arte medievale.\n                                    La collezione permanente del Met contiene più di due milioni di opere d'arte, suddivise in diciannove sezioni. Sono permanentemente esposte opere risalenti all'antichità classica e all'antico Egitto, dipinti e sculture di quasi tutti i più grandi maestri Europei e una vasta collezione di arte statunitense e moderna."
                          )
                        ])
                      ])
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("GmapMap", {
                staticClass: "map",
                attrs: {
                  center: { lat: 40.7794, lng: -73.9632 },
                  zoom: 15,
                  "map-type-id": "terrain"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("ProssimiTour", {
                attrs: {
                  title: "Potrebbe interessarti",
                  subtitle: "Soluzioni di viaggio pensate per te"
                }
              })
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fbb9df4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fbb9df4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/Detail.vue
// module id = null
// module chunks = 